export enum OrderByDirection {
  asc = 'asc',
  desc = 'desc',
}
